import axios from '@/utils/axios';
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        itemTypeGroup: null,
        itemTypeGroups: []
    },
    mutations: {
        setItemTypeGroup(state, payload) {
            state.itemTypeGroup = payload;
        },
        setItemTypeGroups(state, payload) {
            state.itemTypeGroups = payload;
        },
        clearItemTypeGroups(state) {
            state.itemTypeGroups = [];
        }
    },
    actions: {
        storeItemTypeGroup({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `${rootState.warehouse.routePrefix}/item-type-groups`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    reject(error);
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                })
            });
        },
        updateItemTypeGroup({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `${rootState.warehouse.routePrefix}/item-type-groups/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    reject(error);
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                })
            });
        },
        removeItemTypeGroup({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.warehouse.routePrefix}/item-type-groups/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => resolve(response))
                .catch(error => {
                    reject(error);
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                })
            });
        },
        fetchItemTypeGroup({rootState, dispatch, commit}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/item-type-groups/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setItemTypeGroup', response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                })
            });
        },
        fetchItemTypeGroups({rootState, dispatch, commit}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/item-type-groups?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setItemTypeGroups', response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                })
            });
        },
        clearItemTypeGroups({commit}) {
            commit('clearItemTypeGroups');
        }
    }
}